import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import random from "lodash/fp/random";
import flow from "lodash/fp/flow";
import find from "lodash/fp/find";
import isString from "lodash/fp/isString";
import manualEstimatesDialogCtrl from "./../../pages/route/manualEstimatesDialog/manualEstimatesDialog.controller.js";
import manualEstimatesDialog from "./../../pages/route/manualEstimatesDialog/manualEstimatesDialog.html";
class Controller {
  constructor(Events, $injector, $mdDialog) {
    "ngInject";

    this.selected = [];
    this.Events = Events;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.enableEdit = false;
    this.enableSubmit = false;
    this.stationsEdit = false;
  }

  $onInit() {
    const removeSource = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.name = item.note ? `${item.name} - ${item.note}` : item.name;

      return item;
    };
    const getUniqueIndex = () => random(1, 50000);

    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const showErrorEvent = this.Events.eventsType.onShowErrorNotification;
    const markDisabled = (item) => {
      item.isDisabled = true;
      return item;
    };
    const addIndex = (item) => {
      item.index = getUniqueIndex() + getUniqueIndex();

      return item;
    };

    this.items = flow([map(markDisabled), map(addIndex)])(this.items);
    this.onAutoCompleteSearch = (text) => {
      if (isString(text)) {
        const request = this.$injector.get(this.resource).search(text);
        return request.$promise.then((list) => map(removeSource)(list.hits));
      }
    };

    this.enableStationsEdit = () => {
      this.stationsEdit = true;
    };
    this.onAutoCompleteSelect = (item, index) => {
      if (item.name) {
        const isAdded = find((obj) => obj.name === item.name.name)(this.items);

        if (!isAdded) {
          this.items[index] = assign(item.name, {
            isDisabled: item.isDisabled,
            index: getUniqueIndex(),
          });
        } else {
          this.items[index] = {
            isDisabled: false,
            name: "",
            index: getUniqueIndex(),
          };
          this.Events.emit(showNotificationEvent, {
            message: `This station ${item.name.name} is already added.`,
          });
        }
      }
    };

    this.removeItem = (index, item) => {
      if (this.items.length === 2) {
        this.Events.emit(showErrorEvent, {
          message: `There must be at least two stations`,
        });
        return;
      }
      if (item.name) {
        const confirm = this.$mdDialog
          .confirm()
          .title(`Are you sure you want to remove "${item.name}"?`)
          .textContent("If you chose to remove it you can add it again.")
          .ok("Remove")
          .cancel("Cancel");

        this.$mdDialog.show(confirm).then(
          () => {
            this.options = { title: this.title };

            this.options[this.name] = this.items;
            this.items.splice(index, 1);
          },
          () => {}
        );
        this.enableSubmit = true;
      } else {
        this.items.splice(index, 1);
      }
    };

    this.confirmItem = (index, item) => {
      if (item && item.name && item._id) {
        this.options = { title: this.title };
        this.options[this.name] = this.items;
        this.items[index].isDisabled = true;
        this.enableSubmit = true;
      }
    };
    this.checkManualEstimatesSchedulesToSubmit = () => {
      this.manualSchedulesIds = [];
      this.routeSchedules.forEach((schedule) => {
        if (schedule.manual_estimates && schedule.active.value) {
          this.manualSchedulesIds.push(schedule._id.value);
        }
      });
      if (this.manualSchedulesIds.length !== 0) {
        const manualEstimates = this.$mdDialog.show({
          controller: manualEstimatesDialogCtrl,
          controllerAs: "$ctrl",
          template: manualEstimatesDialog,
          locals: {
            routeSchedules: this.routeSchedules,
            manualSchedulesIds: this.manualSchedulesIds,
          },
        });
        manualEstimates.then(
          () => {
            this.submitStations();
          },
          () => {}
        );
      } else {
        this.submitStations();
      }
    };

    this.submitStations = () => {
      // Must start by adding 2 stations on an empty route
      if (this.items.length < 2) {
        this.Events.emit(showErrorEvent, {
          message: `There must be at least two stations to submit`,
        });
        return;
      }
      // Having filled but not confirmed field
      const unconfirmedField = this.items.find(
        (obj) => obj.name !== null && !obj.isDisabled
      );
      if (unconfirmedField) {
        this.Events.emit(showErrorEvent, {
          message: `You must confirm all the filled fields first`,
        });
        return;
      }
      // Must have at least one edited field
      if (!this.enableSubmit) {
        this.Events.emit(showErrorEvent, {
          message: `You must edit or add at least one station to submit changes`,
        });
        return;
      }

      this.items = this.items.filter((obj) => obj.name !== null);
      this.options.stations = this.items;
      this.Events.emit(this.eventName, this.options);
      this.stationsEdit = false;
      this.enableSubmit = false;
    };
    this.editItem = (index) => {
      this.items[index].isDisabled = false;
    };

    this.addItem = () => {
      this.items.push({ isDisabled: false, name: "", index: getUniqueIndex() });
    };

    this.editSorting = () => {
      this.enableEdit = true;
    };

    this.confirm = () => {
      const options = { title: this.title };
      options[this.name] = this.items;

      this.enableEdit = false;
      this.Events.emit(this.eventName, options);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/sortableStations/sortableStations.controller.js